import { useEffect, useState } from "react";
import RatesService from "../services/rates_services";

import firebase from 'firebase/app';
import swal from "sweetalert";
import UserService from "../services/user_service";


const SelectJurisdiction: React.FC<{ rol: string, currentJurisdiction: string, userId: string }> = (props) => {
    const [rates, setRates] = useState<firebase.firestore.QueryDocumentSnapshot>(null);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        new RatesService().getRates().then(rates => {
            const rol = props.rol === "DRIVER" ? "TAXI" : "DELIVERY";
            setRates(rates.docs.find(element => element.id === rol));
            setLoading(false);
        })
    }, []);


    const handleChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        if (e.target.value === (props.currentJurisdiction || "Elegir")) {
            return;
        } else {
            const response = await swal({
                title: "Cuidado",
                text: "¿Quieres cambiar la ubicacion de este usuario?",
                buttons: ["Si, Actualizar", "No, Cerrar"]
            });

            if (response === null) {
                swal("Cargando ...");
                var data = {
                    "jurisdiction": e.target.value,
                    "id": props.userId,
                }
                await new UserService().updateUser(data);
                swal.close();
            }
        }
    }



    if (isLoading) {
        return (
            <div></div>
        );
    }

    return (
        <div className="field">
            <label className="label">Ubicacion</label>

            <div className="select" style={{ width: "60%" }}>
                <select defaultValue={props.currentJurisdiction} style={{ width: "100%" }} onChange={(e)=> handleChange(e)}>
                    {
                        (!!props.currentJurisdiction === false) && (
                            <option value="Elegir">Elegir</option>
                        )
                    }
                    {
                        rates && Object.keys(rates.data()).map<JSX.Element>(element => {
                            return (
                                <option value={element} key={Math.random()}>{element}</option>
                            );
                        })
                    }
                </select>
            </div>
        </div>
    );
}

export default SelectJurisdiction;